import React from 'react'
import HeroSection from '../../components/HeroSection'
// import CompanySection from '../../components/Companies'
// import FlavorTitle from '../../components/Homservices'
import Aslider from '../../components/Aslider.jsx'
import DomeGallery from '../../components/DomeGallery.jsx';
import Whychoose from '../../components/Whychoos.jsx';
import About from '../../components/AboutUs.jsx';
import Playstore from '../../components/playApp.jsx';

const Home = () => {
  return (
    <div>
     <HeroSection />
     <Whychoose/>
     <About/>
      <Playstore />
           <Aslider/>
      {/* <FlavorTitle/> */}
       {/* <CompanySection /> */}
        <div style={{ width: '100vw', height: '100vh' }}>
      <DomeGallery />
    </div>
    </div>
  )
}

export default Home
